module.exports = __webpack_public_path__ + "img/nc.564ebcc5.svg";